import { get, set } from 'idb-keyval';

export async function getDeviceFingerprint(): Promise<string> {
    const KEY = 'device_fingerprint';
    let fingerprint = await get(KEY);

    if (!fingerprint) {
        fingerprint = crypto.randomUUID();
        await set(KEY, fingerprint);
    }

    return fingerprint;
}

